module.exports = __webpack_public_path__ + "img/magicSpace.e5148824.jpg";